import type { LinkType } from "@/components/loan-application/loan-application-form/LinkType";
import type { FormKitNode } from "@formkit/core";

/**
 * Builds a tree of navigation links from formkit nodes.
 * `depth` parameter specifies the max desired tree depth.
 * `id` property is the id of the formkit node.
 */
function getLinks(node: FormKitNode<unknown>, depth: number): LinkType[] {
	// stop recursion when reaching max depth
	if (depth <= 0) {
		return [];
	}

	// dont generate links for inputs
	if (node.type === "input") {
		return [];
	}

	const children = node.children.map((child) =>
		getLinks(child as FormKitNode, depth - 1),
	);

	const link: LinkType = {
		label: node.context?.label ?? node.name,
		id: node.context?.id ?? "",
		children: children.flat(),
	};

	return [link];
}

export function getApplicationFormNavigationLinks(
	node: FormKitNode | null,
): LinkType[] {
	if (!node) {
		return [];
	}

	// ensure that root node exisists
	const offerteAanvraag = node.at("OfferteAanvraag");
	if (!offerteAanvraag) {
		return [];
	}

	// do not include the root link in output
	const links = getLinks(offerteAanvraag, 3);
	return links[0]?.children ?? [];
}
